import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { mailboxFilterHelper,mailboxFilterState} from './mailbox-filter.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core'; 
import { MailboxfilterService } from '../mailboxfilter-service/mailboxfilter.service';
import { Mailboxfilter } from '../mailboxfilter-service/mailboxfilter.model';

 
@Component({
 selector: 'app-mailbox-filter',
  templateUrl: './mailbox-filter.component.html',
  styleUrls: ['./mailbox-filter.component.scss'],
  providers : [ mailboxFilterHelper]
  })

export class MailboxFilterComponent extends BaseFpxFormComponent<mailboxFilterHelper, mailboxFilterState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public mailboxFilterHelper: mailboxFilterHelper,
    public mailboxfilterService: MailboxfilterService,
    private validatorService: ValidatorService
    
  ) {
    super(formBuilder, router,controlContainer, mailboxFilterHelper);
  }
   protected override doPreInit(): void {

   this.addFormControl('FieldId_2', '',  [Validators.required]    ,[],'blur',1,false,0);			   		 
	this.setDataService(this.mailboxfilterService);
  }
 

  protected override doPostInit(): void {
   
  }
  
}
